module.exports = __webpack_public_path__ + "static/media/icon_edit.94d12096.svg";